import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import CustomTypo from '../../components/CustomTypo';
import DrawerCustom from '../../components/DrawerCustom';
import { TextFieldComponent } from '../../components/FormElement';
import validators from '../../utils/validators';
import Button from '../../components/ButtonCustom';
import { getAppCfg } from '../../utils/common';

const useStyles = makeStyles((theme) => ({

}));

export default function ReclaimPurchaseTransactionCodeView(props) {
    const { t } = useTranslation();
    const classes = useStyles();

    const { onSubmit, onHandleChange, transactionCode } = props;

    console.log("transactioncode ===", transactionCode);

    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={props.onClose}
                title={t('reclaim_purchase_transaction_code')}
                children={
                    <Grid item >
                        <Grid item xs={12}>
                            <Grid xs={12} item container justify='center'>
                                <CustomTypo mg_top_xl variant='body2' light center>{t('reclaim_purchase_transaction_code_intro')}</CustomTypo>
                            </Grid>
                            <Form
                                onSubmit={onSubmit}
                                render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                    <Grid xs={12} container item justify='center' className={classes.form}>
                                        <Grid xs={12} item container>
                                            <Field
                                                name="transaction_code"
                                                component={TextFieldComponent}
                                                placeholder={t('reclaim_purchase_transaction_code_place_holder')}
                                                isEdit={true}
                                                color='default'
                                                validate={validators.composeValidators(validators.required)}
                                                onCustomChange={(value) => onHandleChange(value)}
                                                defaultValue={transactionCode ? transactionCode : null}
                                            />
                                        </Grid>
                                        <Grid xs={12} item container justify='center' className={classes.button}>
                                            <Button color='primary' fullWidth onClick={handleSubmit} id="btn_reclaim_transaction_code_submit">{t('btn_submit')}</Button>
                                        </Grid>
                                    </Grid>
                                )}
                            />
                        </Grid>
                    </Grid>
                }
            />
        </div>
    )
}